
<template>
  <div>
    <div class="row gy-2">
      <div class="col-12">
        <h5 class="mb-3">List of Your Applications</h5>
        <div class="row mb-3 gy-2 justify-content-between">
          <div class="col-md-6 col-lg-4 d-flex">
            <div class="input-group w-auto">
              <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage" :options="pageOptions"></b-form-select>
              <select @change="fetchItems()" v-model="defaultStatus" class="form-select flex-grow-1">
                <option value="" disabled selected>-- sort by status --</option>
                <option :value="null"> All </option>
                <option v-for="(status, tIndex) in statusOptions"
                        :value="status.value" :key="tIndex" > {{status.label}} </option>
              </select>
            </div>
          </div>
          <div class="col-md-5">
            <div class="input-group mb-0">
              <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control" placeholder="Search here..." aria-label="Search here..." aria-describedby="button-search_TB">
              <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span class="ri ri-search-line"></span></button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <p class="mb-0">Showing {{paginationInfo}} results</p>
        </div>
        <div class="card">
          <div class="card-body p-3">
            <div class="table-responsive mb-0 loading-viewport">
              <CommonSpinner v-if="isLoading" :box="true" />
              <b-table striped hover ref="selectableTable" :items="pageData.data"
                :fields="columns" responsive="sm"  align="middle">
                <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                  v-slot:[`head(${column.key})`] >
                    <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                    d-flex align-items-center">
                      {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                    </div>
                </template>
                <template v-slot:cell(friendly_id)="data">
                  <div style="min-width:10rem;" @click="navigateTo(data.item.id)"
                  v-if="data.item.opportunity" class="cursor-pointer">
                    {{ data.item.opportunity.friendly_id }}
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <div style="min-width:15rem;" @click="navigateTo(data.item.id)" 
                    v-if="data.item.opportunity" class="cursor-pointer">
                    {{ data.item.opportunity.title }}
                  </div>
                </template>
                <template v-slot:cell(mobile)="data">
                  <div style="min-width:7rem;" @click="navigateTo(data.item.id)" 
                  v-if="data.item.opportunity" class="cursor-pointer">
                    {{ data.item.opportunity.mobile }}
                  </div>
                </template>
                <template v-slot:cell(email)="data">
                  <div style="min-width:7rem;" @click="navigateTo(data.item.id)" 
                  v-if="data.item.opportunity" class="cursor-pointer">
                    {{ data.item.opportunity.email }}
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <div style="min-width:10rem;" @click="navigateTo(data.item.id)" class="cursor-pointer">
                    <span v-html="statusBadge(data.item.status)"></span>
                  </div>
                </template>
                <template v-slot:cell(shortlisted_at)="data">
                  <div style="min-width:8rem;" @click="navigateTo(data.item.id)" class="cursor-pointer">
                    {{ $filters.date(data.item.shortlisted_at, 1) }}
                  </div>
                </template> 
                <template v-slot:cell(action)="data">
                  <div class="dropdown dropstart no-arrow">
                    <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                      role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="ri-more-2-fill"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <button @click.prevent="navigateTo(data.item.id)" class="dropdown-item"
                          type="button"> View Details </button>
                      </li>
                    </ul>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <b-pagination v-model="currentPage" :limit="4" class="pagination-rounded"
          :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import _ from 'lodash';
import CommonPortlet from '@/components/portlets/CommonPortlet.vue';
import { commonSortingMixin } from '@/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
  name: "opportunity-matches",
  mixins: [
    commonSortingMixin,
    commonPaginationMixin,
  ],
  components:{
    CommonPortlet,
  },
  data() {
    return {
      isLoading: false,
      defaultStatus: null,
      searchQuery:"",
      columns: [
        "action",
        {
          key: "friendly_id",
          label: "ID",
        },
        {
          key: "title",
          label: "Title",
        },
        {
          key: "mobile",
          label: "Phone Number",
        },
        {
          key: "email",
          label: "Contact email",
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "shortlisted_at",
          label: "Shortlisted on",
          sortable: true
        }
      ],
      sortBy: {
        sort_column: "created_at",
        sort_direction: "desc"
      },
      statusOptions:[
        { value: 'shortlisted', label: "Shortlisted" },
        { value: 'applied', label: "Applied" },
        { value: 'rejected_by_employer', label: "Rejected by Employer" },
        { value: 'accepted_shortlisting', label: "Accepted Shortlisting" },
        { value: 'rejected_shortlisting', label: "Rejected Shortlisting" },
        { value: 'acceptance_time_elapsed', label: "Acceptance Time Elapsed" },
        { value: 'invited_for_interview', label: "Invited for Interview" },
        { value: 'accepted_interview', label: "Accepted Interview" },
        { value: 'rejected_interview', label: "Rejected Interview" },
        { value: 'enrolled_in_training', label: "Enrolled in Training" },
        { value: 'offered_employment', label: "Offered Employment" },
        { value: 'accepted_employment', label: "Accepted Employment" },
        { value: 'rejected_employment', label: "Rejected Employment" },
        { value: 'denied_employment', label: "Denied Employment" },
        { value: 'employed', label: "Employed" },
      ],
      pageData:{
        data: []
      },
    }
  },
  methods: {
    navigateTo(id){
      this.$router.push({path:`/applications/${id}`});
    },
    updateSearchQuery: _.debounce(function(string) {
      this.fetchItems()
    }, 2000),
    fetchItems(page, per_page = null){
      let payload = {page: page || 1, per_page: per_page || this.itemsPerPage,
        ...this.sortBy
      }
      if(this.searchQuery){ payload.search = this.searchQuery }
      if(this.defaultStatus){ payload.status = this.defaultStatus }
      this.isLoading = true
      this.$http.get(`/opportunity-matches?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          this.isLoading = false
          if(response.data.success){
            this.pageData = response.data.data
            this.initializeAll();
          }
        })
    },
    initializeAll(){

    },
  },
  mounted() {
    this.fetchItems()
  },
}
</script>

